import { ReflectUtils } from "@dooboostore/core";
var InjectSituationType = /* @__PURE__ */ ((InjectSituationType2) => {
  InjectSituationType2["INDEX"] = "SIMPLE_BOOT_CORE://Inject/INDEX";
  return InjectSituationType2;
})(InjectSituationType || {});
class SituationTypeContainer {
  constructor({ situationType, data, index }) {
    this.situationType = situationType;
    this.data = data;
    this.index = index;
  }
}
class SituationTypeContainers {
  constructor(containers) {
    this.containers = [];
    if (containers) {
      this.containers.push(...containers);
    }
  }
  push(...item) {
    this.containers.push(...item);
  }
  get length() {
    return this.containers.length;
  }
  find(predicate, thisArg) {
    return this.containers.find(predicate);
  }
}
const isTargetSymbol = (config) => {
  return "symbol" in config && config.symbol !== void 0;
};
const isTargetType = (config) => {
  return "type" in config && config.type !== void 0;
};
const isTargetScheme = (config) => {
  return "scheme" in config && config.scheme !== void 0;
};
const isTargetFactory = (config) => {
  return "factory" in config && typeof config.factory === "function" && !("symbol" in config) && !("type" in config) && !("scheme" in config);
};
const isTargetNone = (config) => {
  return !("symbol" in config) && !("type" in config) && !("scheme" in config) && !isTargetFactory(config);
};
const InjectMetadataKey = Symbol.for("simple-boot:inject-metadata");
const injectProcess = (config, target, propertyKey, parameterIndex) => {
  if (propertyKey && typeof target === "object") {
    const otarget = target;
    target = target.constructor;
    const saves = Reflect.getOwnMetadata(InjectMetadataKey, target, propertyKey) || [];
    const type = ReflectUtils.getParameterTypes(otarget, propertyKey)[parameterIndex];
    saves.push({ index: parameterIndex, config, propertyKey, type });
    ReflectUtils.defineMetadata(InjectMetadataKey, saves, target, propertyKey);
  } else if (!propertyKey || typeof target === "function") {
    const existingInjectdParameters = ReflectUtils.getMetadata(InjectMetadataKey, target) || [];
    const type = ReflectUtils.getParameterTypes(target)[parameterIndex];
    existingInjectdParameters.push({ index: parameterIndex, config, type });
    ReflectUtils.defineMetadata(InjectMetadataKey, existingInjectdParameters, target);
  }
};
function Inject(configOrTargetOrSymbolOrType, propertyKey, parameterIndex) {
  if (propertyKey && parameterIndex !== void 0) {
    injectProcess({}, configOrTargetOrSymbolOrType, propertyKey, parameterIndex);
  } else {
    return (target, propKey, paramIndex) => {
      let finalConfig;
      if (typeof configOrTargetOrSymbolOrType === "symbol") {
        finalConfig = { symbol: configOrTargetOrSymbolOrType };
      } else if (typeof configOrTargetOrSymbolOrType === "function") {
        finalConfig = { type: configOrTargetOrSymbolOrType };
      } else {
        finalConfig = configOrTargetOrSymbolOrType || {};
      }
      injectProcess(finalConfig, target, propKey, paramIndex);
    };
  }
}
const getInject = (target, propertyKey) => {
  return ReflectUtils.findMetadata(InjectMetadataKey, target, propertyKey) ?? [];
};
const inject = Inject;
export {
  Inject,
  InjectSituationType,
  SituationTypeContainer,
  SituationTypeContainers,
  getInject,
  inject,
  isTargetFactory,
  isTargetNone,
  isTargetScheme,
  isTargetSymbol,
  isTargetType
};
//# sourceMappingURL=Inject.js.map
